import * as Yup from 'yup';
import { getUserShape } from 'validators/Common/baseUserValidator';

export class CreateMemberValidator {
  public get schema() {
    return Yup.object().shape({
      warehouseId: Yup.number()
        .typeError('Selecione o armazém')
        .required('Selecione o armazém'),
      user: Yup.object().shape({
        ...getUserShape(),
      }),
    });
  }
}
